import { createFileRoute, Link } from "@tanstack/react-router";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export const Route = createFileRoute("/cookies")({
  head: () => ({
    meta: [
      { title: "Cookie Policy — AdKavi" },
      {
        name: "description",
        content:
          "Learn what cookies AdKavi uses and how to manage your cookie preferences.",
      },
      { property: "og:title", content: "Cookie Policy — AdKavi" },
      { property: "og:description", content: "What cookies AdKavi uses and how to manage your preferences." },
      { property: "og:url", content: "https://adkavi.ai/cookies" },
    ],
    links: [{ rel: "canonical", href: "https://adkavi.ai/cookies" }],
  }),
  component: CookiePolicy,
});

function CookiePolicy() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main className="mx-auto max-w-3xl px-6 py-20">
        <h1 className="text-4xl font-bold tracking-tight">Cookie Policy</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Last updated: April 2026
        </p>

        <div className="prose prose-invert mt-10 space-y-8 text-foreground">
          <section>
            <h2 className="text-xl font-semibold">What are cookies?</h2>
            <p className="mt-2 text-muted-foreground">
              Cookies are small text files stored on your device when you visit
              a website. They help sites remember your preferences and improve
              your experience.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold">Cookies we use</h2>
            <ul className="mt-3 space-y-3 text-muted-foreground">
              <li>
                <strong className="text-foreground">Essential cookies —</strong>{" "}
                Required for authentication, security, and core functionality
                like remembering you while you're signed in. These cannot be
                disabled.
              </li>
              <li>
                <strong className="text-foreground">Analytics cookies —</strong>{" "}
                Help us understand how visitors use AdKavi so we can improve the
                product. Anonymous usage data only.
              </li>
              <li>
                <strong className="text-foreground">Marketing cookies —</strong>{" "}
                Used to measure ad campaign performance and personalize content.
                Off by default.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold">Managing your preferences</h2>
            <p className="mt-2 text-muted-foreground">
              You can change your cookie preferences at any time by clearing
              your browser's site data for AdKavi, which will re-trigger our
              consent banner. You can also disable cookies entirely through
              your browser settings.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold">Third parties</h2>
            <p className="mt-2 text-muted-foreground">
              AdKavi uses trusted infrastructure providers (such as Supabase
              and Stripe) which may set essential cookies required to operate
              their services securely. We never sell your data.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold">Contact</h2>
            <p className="mt-2 text-muted-foreground">
              Questions about this policy? Email{" "}
              <a
                href="mailto:support@adkavi.com"
                className="text-primary underline underline-offset-2"
              >
                support@adkavi.com
              </a>
              . See also our{" "}
              <Link
                to="/privacy"
                className="text-primary underline underline-offset-2"
              >
                Privacy Policy
              </Link>
              .
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
